var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(" Settings ")]),_c('v-spacer'),_c('div')],1),_c('v-divider'),_c('style-sheet-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }